import React, { useEffect } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./OfficeCarousel.css";
import Map from "../Map/Map";
import WorkIcon from "@mui/icons-material/Work";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";

const OfficeCarousel = () => {

    useEffect(() => {
        const $cont = document.querySelector('.cont');
        const $elsArr = document.querySelectorAll('.el');
        const $closeBtnsArr = document.querySelectorAll('.el__close-btn');

        if ($cont) {
            setTimeout(() => {
                $cont.classList.remove('s--inactive');
            }, 200);
        }

        $elsArr.forEach(($el) => {
            $el.addEventListener('click', () => {
                if ($el.classList.contains('s--active')) return;
                if ($cont && $el) {
                    $cont.classList.add('s--el-active');
                    $el.classList.add('s--active');
                }
            });
        });

        $closeBtnsArr.forEach(($btn) => {
            $btn.addEventListener('click', function (e) {
                e.stopPropagation();
                if ($cont) {
                    $cont.classList.remove('s--el-active');
                }
                const activeEl = document.querySelector('.el.s--active');
                if (activeEl) {
                    activeEl.classList.remove('s--active');
                }
            });
        });
    }, []);

    return (
        <>
            <div className="cont s--inactive">
                <div className="cont__inner">
                    {/* El componente 1 */}
                    <div className="el">
                        <div className="el__overflow">
                            <div className="el__inner">
                                <div className="el__bg"></div>
                                <div className="el__preview-cont">
                                    <h2 className="el__heading">Samacá</h2>
                                </div>
                                <div className="el__content">
                                    <div className="el__text">Samacá</div>

                                    <div className='map-container'>
                                        <Map lat={5.491746064707327} lng={-73.48457741690831}/>
                                    </div>

                                    <div className="details">
                                        <div className="text-info">
                                            <WorkIcon style={{ marginRight: '15px' }} />
                                            Roca Seguros Samacá
                                        </div>
                                        <div className="text-info">
                                            <LocationOnIcon style={{ marginRight: '15px' }} />
                                            Calle 4 #4-99
                                        </div>
                                        <div className="text-info">
                                            <LocalPhoneIcon style={{ marginRight: '15px' }} />
                                            (608) 765 9551
                                        </div>
                                        <div className="text-info">
                                            <PhoneAndroidIcon style={{ marginRight: '15px' }} />
                                            3112345678
                                        </div>
                                    </div>

                                    <div className="el__close-btn"></div>
                                </div>
                            </div>
                        </div>
                        <div className="el__index">
                            <div className="el__index-back">Samacá</div>
                            <div className="el__index-front">
                                <div className="el__index-overlay" data-index="Samacá">Samacá</div>
                            </div>
                        </div>
                    </div>

                    {/* El componente 2 */}
                    <div className="el">
                        <div className="el__overflow">
                            <div className="el__inner">
                                <div className="el__bg"></div>
                                <div className="el__preview-cont">
                                    <h2 className="el__heading">Sogamoso</h2>
                                </div>
                                <div className="el__content">
                                    <div className="el__text">Sogamoso</div>

                                    <div className='map-container' >
                                        <Map lat={5.816649438295347} lng={-73.03398791654226}/>
                                    </div>

                                    <div className="details">
                                        <div className="text-info">
                                            <WorkIcon style={{ marginRight: '15px' }} />
                                            Roca Seguros Sogamoso
                                        </div>
                                        <div className="text-info">
                                            <LocationOnIcon style={{ marginRight: '15px' }} />
                                            Calle 9 #26-98
                                        </div>
                                        <div className="text-info">
                                            <LocalPhoneIcon style={{ marginRight: '15px' }} />
                                            (608) 765 9551
                                        </div>
                                        <div className="text-info">
                                            <PhoneAndroidIcon style={{ marginRight: '15px' }} />
                                            3112345678
                                        </div>
                                    </div>

                                    <div className="el__close-btn"></div>
                                </div>
                            </div>
                        </div>
                        <div className="el__index">
                            <div className="el__index-back">Sogamoso</div>
                            <div className="el__index-front">
                                <div className="el__index-overlay" data-index="Sogamoso">Sogamoso</div>
                            </div>
                        </div>
                    </div>

                    {/* El componente 3 */}

                    {/* El componente 5 */}
                    <div className="el">
                        <div className="el__overflow">
                            <div className="el__inner">
                                <div className="el__bg"></div>
                                <div className="el__preview-cont">
                                    <h2 className="el__heading">Duitama</h2>
                                </div>
                                <div className="el__content">
                                    <div className="el__text">Duitama</div>

                                    <div className='map-container' >
                                        <Map lat={5.816649438295347} lng={-73.03398791654226}/>
                                    </div>

                                    <div className="details">
                                        <div className="text-info">
                                            <WorkIcon style={{ marginRight: '15px' }} />
                                            Roca Seguros Duitama
                                        </div>
                                        <div className="text-info">
                                            <LocationOnIcon style={{ marginRight: '15px' }} />
                                            Calle 9 #26-98
                                        </div>
                                        <div className="text-info">
                                            <LocalPhoneIcon style={{ marginRight: '15px' }} />
                                            (608) 765 9551
                                        </div>
                                        <div className="text-info">
                                            <PhoneAndroidIcon style={{ marginRight: '15px' }} />
                                            3112345678
                                        </div>
                                    </div>

                                    <div className="el__close-btn"></div>
                                </div>
                            </div>
                        </div>
                        <div className="el__index">
                            <div className="el__index-back">Duitama</div>
                            <div className="el__index-front">
                                <div className="el__index-overlay" data-index="Duitama">Duitama</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='resp-cont'>
                <div className='off'>
                    <img src='/Assets/Duitama.JPG' alt='info' className='resp-img'/>
                    <div className='resp-text'>
                        <div className="text-info bl">
                            <WorkIcon style={{ marginRight: '15px' }} />
                            Roca Seguros Duitama
                        </div>
                        <div className="text-info bl">
                            <LocationOnIcon style={{ marginRight: '15px' }} />
                            Calle 9 #26-98
                        </div>
                        <div className="text-info bl">
                            <LocalPhoneIcon style={{ marginRight: '15px' }} />
                            (608) 765 9551
                        </div>
                        <div className="text-info bl">
                            <PhoneAndroidIcon style={{ marginRight: '15px' }} />
                            3112345678
                        </div>
                    </div>  
                </div>
            </div>

            <div className='resp-cont'>
                <div className='off'>
                    <img src='/Assets/Sogamoso.jpg' alt='info' className='resp-img'/>
                    <div className='resp-text'>
                        <div className="text-info bl">
                            <WorkIcon style={{ marginRight: '15px' }} />
                            Roca Seguros Sogamoso
                        </div>
                        <div className="text-info bl">
                            <LocationOnIcon style={{ marginRight: '15px' }} />
                            Calle 9 #26-98
                        </div>
                        <div className="text-info bl">
                            <LocalPhoneIcon style={{ marginRight: '15px' }} />
                            (608) 765 9551
                        </div>
                        <div className="text-info bl">
                            <PhoneAndroidIcon style={{ marginRight: '15px' }} />
                            3112345678
                        </div>
                    </div>  
                </div>
            </div>

            <div className='resp-cont'>
                <div className='off'>
                    <img src='/Assets/Samaca.jpg' alt='info' className='resp-img'/>
                    <div className='resp-text'>
                        <div className="text-info bl">
                            <WorkIcon style={{ marginRight: '15px' }} />
                            Roca Seguros Samacá
                        </div>
                        <div className="text-info bl">
                            <LocationOnIcon style={{ marginRight: '15px' }} />
                            Calle 9 #26-98
                        </div>
                        <div className="text-info bl">
                            <LocalPhoneIcon style={{ marginRight: '15px' }} />
                            (608) 765 9551
                        </div>
                        <div className="text-info bl">
                            <PhoneAndroidIcon style={{ marginRight: '15px' }} />
                            3112345678
                        </div>
                    </div>  
                </div>
            </div>
        </>
    );
};

export default OfficeCarousel;